import React from "react";
import { motion } from "framer-motion";

import enrollIcon from "../../Images/icons-graduation-cap.png";
import quizIcon from "../../Images/icons8-brain-50.png";
import coinIcon from "../../Images/rupee-icon.png";

/* 🔹 Animation Variant */
const cardVariant = {
  hidden: {
    opacity: 0,
    y: -40,
  },
  visible: (index) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: index * 0.2,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

const steps = [
  {
    icon: enrollIcon,
    title: (
      <>
        Enroll in a <span className="text-purple">Course</span>
      </>
    ),
    desc: "Choose an exam-oriented course designed by experts. Enroll once and start structured preparation.",
    btn: "Watch how to enroll",
  },
  {
    icon: quizIcon,
    title: (
      <>
        Attempt Quizzes & <span className="text-purple">Contests</span>
      </>
    ),
    desc: "Attempt practice quizzes and skill-based contests to test accuracy, speed, and consistency.",
    btn: "Watch how to attempt",
  },
  {
    icon: coinIcon,
    title: (
      <>
        Earn Coins & <span className="text-purple">Redeem</span>
      </>
    ),
    desc: "Earn performance-based coins and redeem them within the platform as per applicable rules.",
    btn: "Watch how to redeem",
  },
];

const HowItsWorks = () => {
  return (
    <section className="relative w-full overflow-hidden">

      {/* 🔴 TOP PURPLE AREA (MOBILE SAFE) */}
      <div
        className="
          bg-bgBlue
          flex
          flex-col
          items-center
          text-center
          px-6
          pt-10
          pb-32
          sm:pb-28
          md:h-[330px]
        "
      >
        <h2
          className="
            text-[28px]
            sm:text-[34px]
            md:text-[40px]
            font-extrabold
            text-white
            leading-tight
          "
        >
          How <span className="text-purple">Learn2Earn24x7</span> Works
        </h2>

        <p
          className="
            text-white/70
            mt-3
            text-[13px]
            sm:text-[14px]
            md:text-[15px]
          "
        >
          Skill-based learning & assessment platform
        </p>
      </div>

      {/* ⚪ WHITE AREA */}
      <div className="bg-white pt-28 pb-24">
        <div
          className="
            max-w-6xl
            mx-auto
            px-6
            grid
            grid-cols-1
            md:grid-cols-3
            gap-10
            -mt-40
            sm:-mt-48
            md:-mt-56
          "
        >
          {steps.map((item, index) => (
            <motion.div
              key={index}
              custom={index}
              variants={cardVariant}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              className="
                group
                relative
                bg-white
                rounded-[24px]
                px-8
                pt-12
                pb-10
                min-h-[360px]
                text-center
                border
                border-bgBlue/40
                shadow-[0_10px_22px_rgba(0,0,0,0.14)]
                flex
                flex-col
              "
            >
              {/* Step Number */}
              <div className="absolute -top-6 left-1/2 -translate-x-1/2">
                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center ring-2 ring-bgBlue">
                  <div className="w-8 h-8 rounded-full bg-purple text-white text-sm font-bold flex items-center justify-center">
                    0{index + 1}
                  </div>
                </div>
              </div>

              {/* Icon */}
              <div className="flex justify-center mb-6">
                <div
                  className="
                    w-20 h-20
                    rounded-2xl
                    border border-bgBlue/30
                    bg-gradient-to-br from-[#F8F6FF] to-[#EEE9FF]
                    flex items-center justify-center
                    shadow-[0_8px_18px_rgba(0,0,0,0.12)]
                  "
                >
                  <img
                    src={item.icon}
                    alt="icon"
                    className="w-10 h-10 object-contain"
                  />
                </div>
              </div>

              {/* Title */}
              <h3 className="text-[21px] font-bold text-[#2B0A3D]">
                {item.title}
              </h3>

              {/* Accent Line */}
              <div className="w-10 h-[3px] mx-auto my-3 rounded-full bg-gradient-to-r from-purple to-lightPink"></div>

              {/* Description */}
              <p className="text-[#5F5F5F] text-[15px] leading-6 mb-6">
                {item.desc}
              </p>

              {/* Button */}
              <button
                className="
                  mt-auto
                  mx-auto
                  inline-flex
                  items-center
                  gap-2
                  bg-purple
                  hover:bg-bgBlue
                  text-white
                  text-sm
                  font-medium
                  px-5
                  py-2.5
                  rounded-full
                  transition-colors
                "
              >
                <span
                  className="
                    w-6 h-6
                    rounded-full
                    bg-white
                    flex
                    items-center
                    justify-center
                    text-[#FF8A2B]
                    text-xs
                  "
                >
                  ▶
                </span>
                {item.btn}
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItsWorks;
